module.exports = __webpack_public_path__ + "assets/icon_data.adc4a8d4.svg";